import Errors from '@/classes/errors'
import { get as _get } from 'lodash'

const errorRegexPatterns = {
    CeramicTiles: [
        "bathrooms.*.floor_ceramic_tile_slug",
        "bathrooms.*.walls_ceramic_tile_slug",
        "bathrooms.*.mix_tiles",
        "bathrooms.*.mix_tiles_description",
        "preferences.hallway_floor_ceramic_tile_slug",
    ],
    Electricity: [
        'preferences.customize_electricity_description',
    ],
    Extras: [],
    Floors: [
        'rooms.*.floor_ceramic_tile_slug',
        'rooms.*.floor_parquette_slug',
    ],
    ObjectDetails: [],
    SanitaryEquipment: [],
    Summary: [],
    WallPaints: [
        'rooms.*.standard_color_code',
        'rooms.*.custom_color_code',
        'rooms.*.mixed_colors_description',
    ],
}


function errorIsInRegex(step, testableStr) {
    if (!errorRegexPatterns[step]) {
        console.warn('Step ' + step + ' does not have any patterns to validate for.')
        return false
    }

    for (const regex of errorRegexPatterns[step]) {
        if (new RegExp(regex).test(testableStr)) return true;
    }
    return false;
}

export default {
    state: {
        errorSnackbarVisible: false,
        errorSnackbarContent: null,

        error: new Errors,
        shouldValidateSteps: [],
        step: 'CeramicTiles'
    },

    getters: {
        /**
         * Get the error state
         */
        error: (state, getters) => (step, key) => {
            if (!errorIsInRegex(step, key)) console.error(key + " must be in errorRegexPatterns array");

            return state.error.state(key)
        },

        visibleError: (state, getters) => (step, key) => {
            if (!state.shouldValidateSteps.includes(step)) return false;
            return getters["error"](step, key);
        },

        stepHasErrors: (state, getters) => step => {
            const existingErrorKeys = Object.keys(state.error.errors);

            for (const key of existingErrorKeys) {
                if (errorIsInRegex(step, key)) return true;
            }

            return false;
        },

        stepHasVisibleErrors: (state, getters) => (step) => {
            if (!state.shouldValidateSteps.includes(step)) return false;
            return getters["stepHasErrors"](step);
        },



        hasErrors: (state, getters) => page => {
            if (!Object.keys(state.pageFormFields).includes(page))
                console.error(page + ' is not defined in pageFormFields')

            for (const field of state.pageFormFields[page]) {
                if (state.error.has(field)) return true
            }

            return false
        },
    },

    mutations: {

    },

    actions: {
        goToErrorAnchor({ getters, commit, dispatch }, errorKey) {

        },
    },
};
